export default __webpack_public_path__ + "locales/pl/OAuth.json?hash=b61308cba43aabfd750f036fd2d99fec";